export const PARAM_NAME = 'wd'; /* withDiscount */
